import React from 'react'
import styled from 'styled-components'
import { FormattedMessage, injectIntl } from 'react-intl'
import { colors } from 'shared/assets/styles'
import { styleText } from 'app/common/typography'

const { text } = colors

type Props = {
    textKey: string,
    color?: string,
    typography?: any
}

const UnderlinedTextComponent = (props: Props) => {
    const {
        textKey,
        color = text,
        typography = styleText,
        ...otherProps
    } = props

    return (
        <FormattedMessage id={textKey}>
            {(text: string) => (
                <StyledText
                    {...otherProps}
                    color={color}
                    typography={typography}>
                    {text}
                </StyledText>
            )}
        </FormattedMessage>
    )
}

const StyledText = styled.div`
    ${props => props.typography};
    display: inline-block;
    cursor: pointer;
    color: ${props => props.color};
    text-decoration: underline;
    text-underline-offset: 5px;
`

const UnderlinedText = injectIntl(UnderlinedTextComponent)
export { UnderlinedText }
